import * as React from "react"
import type { IconProps } from "../types"

const DragHandle = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 20, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        ref={ref}
        {...props}
      >
        <path
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.08301 17.5L7.08301 2.5M12.9163 17.5L12.9163 2.5"
        />
      </svg>
    )
  }
)
DragHandle.displayName = "DragHandle"

export default DragHandle
